import React, { useState } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import {
    DialogContent,
    DialogActions,
    DialogContentText,
    Button,
    Tooltip
} from "@material-ui/core";

const AzureMediaPlayer = (props) => {
    const [copyTooltipTitle, setCopyTooltipTitle] = useState("")

    const copyVideoURL = () => {
        navigator.clipboard.writeText(props.videoUrl)
        setCopyTooltipTitle("URL copied!")
    }

    return (
        <React.Fragment>
            {/* <Helmet>
                <link href="//amp.azure.net/libs/amp/latest/skins/amp-default/azuremediaplayer.min.css" rel="stylesheet" />
                <script src="//amp.azure.net/libs/amp/latest/azuremediaplayer.min.js"></script>
            </Helmet> */}
            <DialogContent>
                <DialogContentText>
                    <video
                        //className="azuremediaplayer amp-default-skin"
                        id="vid1"
                        controls
                        width={`${props.width}`}
                        height={`${props.height}`}
                        data-setup='{"nativeControlsForTouch": false}'>
                        <source src={props.videoUrl} />
                        <p className="amp-no-js">
                            To view this video please enable JavaScript, and consider upgrading to a web browser that supports HTML5 video
                        </p>
                    </video>
                </DialogContentText>
            </DialogContent>
            <DialogActions className="isPrintViewHidden">
                <Tooltip
                    placement="top"
                    title={copyTooltipTitle}>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={copyVideoURL}
                    >
                        <FileCopyIcon />
                        Copy URL
                    </Button>
                </Tooltip>
            </DialogActions>
        </React.Fragment>
    )
}

AzureMediaPlayer.porpTypes = {
    videoUrl: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
}
AzureMediaPlayer.defaultProps = {
    width: 640,
    height: 400
}
export default AzureMediaPlayer;
